<template>
	<div class="statistica__per-month">
		<div class="statistica__item">
            <div class="statistica__per-month-title">
                <!--<div class="statistica__per-month-title_text">{{getPeriod}}
                    <i class="icon-calendar" @click="showPopup"></i>
                </div>-->
                <div class="statistica__per-month-title_data-wrap">
                    <div class="statistica__per-month-title_data">
                        Общий
                        <watch :data="commonProfit"
						   :units="'%'"
						>
                        </watch>
                    </div>
                    <div class="statistica__per-month-title_data">
                        Ср.
                        <watch :data="averrangeProfit"
						   :units="'%'"
						>
                        </watch>
                    </div>
                </div>
            </div>
            <div class="statistica__per-month-row">
                <chart :points = "points" :fixedWidth = "320"
                :fixedHeight = "110" :smooth="true" :data="commonProfit"></chart>
            </div>
        </div>
        <transition enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut">
            <div v-show="popup" class="statistica-popup">
                <div class="statistica-changeDate">
                    <div class="statistica-changeDate-item">
                        <span>Выбрать год</span>
                        <select v-model="year">
                            <option v-for="(item,index) in period" :key="index">{{item}}</option>u
                        </select>
                    </div>
                    <input type="button" value="OK" @click="changeDate">
                </div>
            </div>
        </transition>
        <transition enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut">
            <div v-show="false" class="statistica-overlay"></div>
        </transition>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import Chart from '../../../ui-components/ui-mini-linechart';
import Watcher from '../../../ui-components/ui-data-watcher';

export default {
    components: {
        'chart':Chart,
        'watch':Watcher
    },
    data() {
        return {
            points:0,
            year:null,
            type:'percent',
            period:[],
            popup: false,
            commonProfit:0,
            averrangeProfit:0,
        }
    },
    computed : {
        ...mapGetters({
            getProfit:'accountstat/getMonthProfitStrategy'
        }),
        getPeriod() {
            if(this.year === null || this.year === 'Весь период') {
                return ''
            } else {
                return this.year;
            }
        }
    },
	methods: {
        updateChart() {
            let stat = this.getProfit('');
            if (!stat) {
                return;
            }
            let unicYear = UnicYear(stat);
            this.period = [];
            for(let i =0; i < unicYear.length; i++)
                this.period.push(unicYear[i]);
            this.period.unshift('Весь период');
            let data = getPoints(stat, this.year, this.type)
            this.points = data.pointProfit;
            this.commonProfit = data.comProfit;
            this.averrangeProfit = data.avProfit;
        },
        changeDate () {
            if(this.year === 'Весь период')
                this.year = null;
            this.updateChart();
            this.popup = false;
        },
        showPopup () {
            this.popup = true;
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
                  this.updateChart()
                  //this.loading = false;
        });
        this.updateChart();
    }
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "profit-line-widget-desktop",
            handler: handler
        }
    });
}
function sumTo(n, array, type, context) {
  let sum = 0;
  if(type === 'percent') {
    for (var i = 0; i <= n; i++) {
        sum += array[i].profit;
    }
  } else {
     for (var i = 0; i <= n; i++) {
        sum += array[i].profitAbs;
    }
  }
  return sum;
}
function UnicYear (stat) {
    if (!stat)
        return;
    let years = {};
    for (let i = 0; i < stat.length; i++) {
        let str = stat[i].year
        years[str] = true
    }
    return Object.keys(years);
}

function getPoints(stats, year, type) {
     let point = {
         comProfit:0,
         avProfit:0,
         pointProfit:[],
         pointLine:[]
    }
    let typeProfit = stats[0].profit;
    let yearArr = [];
    if(year !== null) {
        for (let i = 0; i < stats.length; i++) {
            if(stats[i].year === parseInt(year))
                yearArr.push(stats[i])
        }
        for(let i = 0; i < yearArr.length; i++) {
            point.pointProfit.push(sumTo(i,yearArr, type));
            point.pointLine.push(sumTo(i, yearArr, type) / (i + 1));
        }
    } else {
        for (let i = 0; i < stats.length; i++) {
            point.pointProfit.push(sumTo(i,stats, type));
            point.pointLine.push(sumTo(i, stats, type) / (i + 1));
        }
    }
    point.comProfit = point.pointProfit[point.pointProfit.length - 1];
    point.avProfit = point.pointLine[point.pointLine.length - 1];
    return point;
}
</script>

<style lang="less" scoped>
.statistica {
    &-popup {
        position: fixed;
        top:40%;
        left:8px;
        right: 8px;
        max-width: 100%;
        height: 150px;
        background: #3d536b;
        border-radius: 8px;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &-overlay {
        position: fixed;
        display: block;
        left: 0;
        margin-right: 8px;
        top:0;
        width: 100%;
        min-height: 100vh;
        background:rgba(0,0,0,0.7);
        z-index: 1;
    }
    &-changeDate {
        display: flex;
        flex-direction: column;
        align-items: center;
        select {
            font-family: Montserrat;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            font-size: 120%;
            background: #fff;
            padding: 4px;
            border-radius: 4px;
        }
        span {
            font-family: Montserrat;
            font-size: 20px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.4px;
            color: #fff;
            margin-right: 16px;
        }
    }
}
input[type="button"]
    {
        height: 40px;
        border-radius: 4px;
        width: 100px;
        background-color: #0fd7b7;
        border: none;
        margin-top: 16px;
        color:#374b62;
        cursor: pointer;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;

        &:disabled
        {
            background-color: #718da8;

            &:hover
            {
              background-color: #718da8;
            }
        }

        &:hover
        {
            background-color: @colors[green];
        }
}
.statistica__item {
    margin-bottom: 8px;
    display: block;
    background: #3d536b;
    border-radius: 4px;
    overflow: hidden;
}
.statistica__per-month {
    width: 100%;
    &-title {
        font-family: Montserrat;
        font-weight: normal;
        font-size: 18px;
        font-style: normal;
        font-stretch: normal;
        //text-transform: uppercase;
        color: #ffffff;
        padding-left: 16px;
        background-color: #3d536b;
        border-bottom: 1px solid #374b62;
        margin-bottom: 0px;
        padding: 8px 8px;
        height: 45px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        &_text {
            display: flex;
            align-items: center;
        }
        &_data {
            display: flex;
            align-items: center;
            &:first-child {
                margin-right: 12px;
            }
            &-wrap {
                display: flex;
                width: 100%;
                justify-content: space-between;
            }
        }
        i {
            margin-left: 8px;
            margin-top: 4px;
        }
        span {
            font-family: Arimo;
            //font-weight: 600;
            margin-right: 8px;
            &:first-child {
                margin-left: 8px;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }

    &-row {
        display: flex;
        justify-content: center;
        padding-top: 8px;
    }

    &-item {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        height: 29px;
        &-title{
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;

            &-day {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 12px;
                color: #ffffff;
            }

            &-date {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 16px;
                color: #aabed2
            }
        }

        &-data {
            padding: 12px 12px 8px 12px;

            &-sum {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: 0.4px;
                text-align: left;
            }

            &-pips {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
            }

            &-probability {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: @colors[green];
                margin-top: 8px;
            }

            &-maxdd {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                color: #ff9292;
                }
        }

        &-chart {
            width: 100%;
            display: block;
            //flex-grow: 1;
            min-height: 200px;
        }
    }
}
</style>
